import './Support.scss';
import React from 'react';
import Button from '../../components/button/Button';
import journeyArrow from '../../assets/img/whiteArrow.svg';
import { useInView } from 'react-intersection-observer';

function Support({t}) {
    const{ ref,inView } = useInView({
        threshold:0,
      })
  return (
    <div className="support-wrapper">
        <div className="support">   
            <div ref={ref} className={`support-content-wrapper animation ${inView ? 'show-support': ""}`}>
                <div className="support-content">
                    <div className="support-capture">
                       {t("support_capture")}
                    </div>
                    <div className="support-description">
                    {t("support_description")}
                    </div>
                    <div className="support-link-wrapper">
                        <a href="https://u24.gov.ua/uk" target="blank">
                            <div className="support-bottom">
                                <div className="learn-more" >{t("support_link")}</div>
                                <img src={journeyArrow} alt="" />
                            </div>
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </div>
    
  );
}

export default Support;